module.exports = __webpack_public_path__ + "img/贾向敬.9dc9fc9a.jpg";